import React, { FC } from 'react';
import MuiDivider, { DividerProps as MuiDividerProps } from '@mui/material/Divider';
import { BpDesignSystem } from '../../types';

export type DividerProps = BpDesignSystem.PropsWithChildren<MuiDividerProps & {}>;

export const Divider: FC<DividerProps> = ({ dataTest, ...props }) => <MuiDivider data-test={dataTest} {...props} />;
